import React from 'react'
import * as Icon from 'react-feather'

export const MODULES_DATA = {
  LOCATIONS: {
    name: 'Locations',
    submodules: {
      LOCATIONS: 'My Locations',
      PENDING: 'Pending Edits',
      CHECKLIST: 'Performance',
      IMAGES: 'Images',
      CSV: 'Import CSV',
      SOCIAL: 'Social Media',
      FAQ: 'FAQ',
      BULK: 'Bulk Edit',
    },
    icon: <Icon.MapPin color="#fff" />,
  },
  POSTS: {
    name: 'Posts',
    submodules: {
      POSTS: 'Posts',
      SCHEDULING: 'Schedules',
    },
    icon: <Icon.Edit color="#fff" />,
  },
  INSIGHTS: {
    name: 'Insights',
    submodules: {
      INSIGHTS: 'Insights',
      KEYWORDS: 'Keywords',
      LOCAL: 'Location Insights',
    },
    icon: <Icon.BarChart2 color="#fff" />,
  },
  SAC: {
    name: 'Sac',
    submodules: {
      REVIEWS: 'Reviews',
      QUESTIONS: 'Questions',
      NPS: 'NPS',
    },
    icon: <Icon.Star color="#fff" />,
  },
}
